import { Link } from "react-router-dom";
import { ArrowUpRight, MessageCircle } from "lucide-react";
import { whatsappLink } from "@/content/site";

const base = "group relative inline-flex items-center justify-center gap-3 h-14 px-7 font-display font-extrabold uppercase tracking-[0.14em] text-[15px] chamfer-sm transition-[background-color,color,transform] duration-300 active:scale-[0.98]";

export const RequestButton = ({ testId = "request-repair-btn", className = "" }) => (
  <Link to="/request-a-repair" data-testid={testId} className={`${base} bg-[var(--red)] text-white hover:bg-[var(--red-hi)] ${className}`}>
    Request a Repair
    <ArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" aria-hidden />
  </Link>
);

export const WhatsAppButton = ({ testId = "whatsapp-btn", className = "" }) => (
  <a href={whatsappLink} target="_blank" rel="noopener noreferrer" data-testid={testId} className={`${base} bg-white text-[var(--ink)] hover:bg-[var(--wa)] ${className}`}>
    <MessageCircle className="h-5 w-5" aria-hidden />
    WhatsApp Us
  </a>
);
